import { useEffect, useState } from "react";
import { gql, useQuery } from "@apollo/client";

export const GET_PROVIDER_TYPE = gql(`
    query ProviderTypeHook {
        provider {
            providerId
            type
        }
    }
`);

export function useIsEnterpriseProvider() {
  const [isEnterpriseProvider, setIsEnterpriseProvider] = useState(true);
  const { loading: providerTypeQueryLoading, data: providerTypeData } =
    useQuery(GET_PROVIDER_TYPE, {
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (!providerTypeQueryLoading && providerTypeData?.provider) {
      setIsEnterpriseProvider(
        providerTypeData.provider.type === "enterprise_provider",
      );
    }
  }, [providerTypeQueryLoading, providerTypeData]);

  return isEnterpriseProvider;
}
